class ConfrimModalController {
  constructor($scope, $uibModalInstance) {
      "ngInject";
      this.name = 'ConfirmModal';

      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;

      $scope.yes = function () {
        $uibModalInstance.yes();
      };

      $scope.no = function () {
        $uibModalInstance.no();
      }

  }





}

export default ConfrimModalController;



// WEBPACK FOOTER //
// ./client/common/modals/ConfirmModal/confrimModal.controller.js